<div class="container-fluid">
  <div class="header">
    <h2>Dados da Empresa</h2>
    <p class="text-muted">Gerencie as informações da sua empresa</p>
  </div>

  <div class="form-container">
    <form [formGroup]="formDadosEmpresa" (ngSubmit)="onSubmit()" class="dados-empresa-form">
      
      <!-- Informações Básicas -->
      <div class="form-section">
        <h4>Informações Básicas</h4>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="nomeFantasia">Nome Fantasia:</label>
              <input 
                type="text" 
                id="nomeFantasia" 
                class="form-control" 
                formControlName="nomeFantasia"
                [readonly]="!editando"
                placeholder="Digite o nome fantasia">
              <small class="text-danger" *ngIf="isFieldInvalid('nomeFantasia')">
                {{ getFieldError('nomeFantasia') }}
              </small>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="cnpj">CNPJ:</label>
              <input 
                type="text" 
                id="cnpj" 
                class="form-control" 
                formControlName="cnpj"
                [readonly]="!editando"
                (input)="formatarCNPJ($event)"
                maxlength="16"
                placeholder="Somente números">
              <small class="text-danger" *ngIf="isFieldInvalid('cnpj')">
                {{ getFieldError('cnpj') }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações de Contato -->
      <div class="form-section">
        <h4>Informações de Contato</h4>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label for="contato">Contato:</label>
              <input 
                type="text" 
                id="contato" 
                class="form-control" 
                formControlName="contato"
                [readonly]="!editando"
                placeholder="Nome do contato">
              <small class="text-danger" *ngIf="isFieldInvalid('contato')">
                {{ getFieldError('contato') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="telefone">Telefone:</label>
              <input 
                type="text" 
                id="telefone" 
                class="form-control" 
                formControlName="telefone"
                [readonly]="!editando"
                (input)="formatarTelefone($event)"
                placeholder="(00) 0000-0000">
              <small class="text-danger" *ngIf="isFieldInvalid('telefone')">
                {{ getFieldError('telefone') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="celular">Celular:</label>
              <input 
                type="text" 
                id="celular" 
                class="form-control" 
                formControlName="celular"
                [readonly]="!editando"
                (input)="formatarTelefone($event)"
                placeholder="(00) 00000-0000">
              <small class="text-danger" *ngIf="isFieldInvalid('celular')">
                {{ getFieldError('celular') }}
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="site">Site:</label>
              <input 
                type="text" 
                id="site" 
                class="form-control" 
                formControlName="site"
                [readonly]="!editando"
                placeholder="www.exemplo.com.br">
              <small class="text-danger" *ngIf="isFieldInvalid('site')">
                {{ getFieldError('site') }}
              </small>
            </div>
          </div>
        </div>
      </div>

      <!-- Endereço -->
      <div class="form-section">
        <h4>Endereço</h4>
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="cep">CEP:</label>
              <input 
                type="text" 
                id="cep" 
                class="form-control" 
                formControlName="cep"
                [readonly]="!editando"
                (input)="formatarCEP($event)"
                placeholder="00000-000">
              <small class="text-danger" *ngIf="isFieldInvalid('cep')">
                {{ getFieldError('cep') }}
              </small>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <label for="bairro">Bairro:</label>
              <input 
                type="text" 
                id="bairro" 
                class="form-control" 
                formControlName="bairro"
                [readonly]="!editando"
                placeholder="Digite o bairro">
              <small class="text-danger" *ngIf="isFieldInvalid('bairro')">
                {{ getFieldError('bairro') }}
              </small>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for="rua">Rua:</label>
              <input 
                type="text" 
                id="rua" 
                class="form-control" 
                formControlName="rua"
                [readonly]="!editando"
                placeholder="Digite a rua">
              <small class="text-danger" *ngIf="isFieldInvalid('rua')">
                {{ getFieldError('rua') }}
              </small>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="numero">Número:</label>
              <input 
                type="text" 
                id="numero" 
                class="form-control" 
                formControlName="numero"
                [readonly]="!editando"
                placeholder="Nº">
              <small class="text-danger" *ngIf="isFieldInvalid('numero')">
                {{ getFieldError('numero') }}
              </small>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="complemento">Complemento:</label>
              <input 
                type="text" 
                id="complemento" 
                class="form-control" 
                formControlName="complemento"
                [readonly]="!editando"
                placeholder="Apartamento, sala, andar, etc.">
            </div>
          </div>
        </div>
      </div>

      <!-- Ações -->
      <div class="form-actions">
        <div class="row">
          <div class="col-md-12">
            <div class="d-flex justify-content-between align-items-center">
              <div class="info-atualizacao" *ngIf="dadosEmpresa">
                <small class="text-muted">
                  <i class="fa fa-clock"></i>
                  Última atualização: {{ dadosEmpresa.dataAtualizacao | date:'dd/MM/yyyy HH:mm' }}
                </small>
              </div>
              <div class="btn-group">
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  (click)="iniciarEdicao()" 
                  *ngIf="!editando">
                  <i class="fa fa-edit"></i> Editar
                </button>
                <button 
                  type="button" 
                  class="btn btn-secondary" 
                  (click)="cancelarEdicao()" 
                  *ngIf="editando">
                  <i class="fa fa-times"></i> Cancelar
                </button>
                <button 
                  type="submit" 
                  class="btn btn-primary" 
                  [disabled]="formDadosEmpresa.invalid || !editando"
                  *ngIf="editando">
                  <i class="fa fa-save"></i> Salvar Alterações
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div> 